export default __webpack_public_path__ + "static/industrial_b.1e98db7d99db82037a354caaef577ea7.png";